import React from "react";
import { Briefcase } from "lucide-react";
import DashboardAvatar from "./DashboardAvatar";

const LatestPlacements = ({ placements = [] }) => (
  <div className="db-card">
    <div className="db-card-head">
      <div className="db-card-head-left">
        <div className="db-card-icon emerald"><Briefcase size={18} /></div>
        <div>
          <div className="db-card-title">Latest Placements</div>
          <div className="db-card-subtitle">{placements.length} students placed</div>
        </div>
      </div>
    </div>
    <div className="db-card-body">
      {placements.map((p, i) => (
        <div key={p._id || i} className="db-list-item">
          <DashboardAvatar name={p.name} />
          <div className="db-list-info">
            <div className="db-list-name">{p.name}</div>
            <div className="db-list-sub">{p.course?.name || ""}</div>
          </div>
          <div className="db-list-right">
            {p.placementSalary ? (
              <>
                <div className="db-list-value-green">{p.placementSalary.toLocaleString()} LPA</div>
                <div className="db-list-value-sub">{p.placementCompany}</div>
              </>
            ) : (
              <span className="db-badge">Placed</span>
            )}
          </div>
        </div>
      ))}
      {placements.length === 0 && <div className="text-muted text-center py-3" style={{ fontSize: "0.8125rem" }}>No placements yet</div>}
    </div>
  </div>
);

export default LatestPlacements;
